import { businessUnitModel, counterPartyTypeModel, maritimeDirectoryModel } from 'model';
import { baseNamedEntityModel } from './base';
import {
  TXT_ALL,
  TXT_RECEIVER,
  TXT_SHIPOWNER,
  TXT_SUPPLIER,
  TXT_AGENT,
  TXT_A_RECEIVER,
  TXT_A_SHIPOWNER,
  TXT_A_SUPPLIER,
  TXT_AN_AGENT
} from '../../../../shared/translations';

export const CounterPartyTypes = {
  ALL: '00000000-0000-0000-0000-000000000000',
  CLIENT: '674a27a2-719f-4d02-bc88-d6145468eab5',
  SHIPOWNER: '843c658e-e227-4269-88fa-bcc4e5a09e69',
  SUPPLIER: '8204ff2a-dca2-4f0d-b0e5-9dad09fd1e56',
  AGENT: '5836f893-9b85-40ee-8b29-6bee12a9c9fa'
};

export const CounterPartyTypeLabels = {
  ALL: TXT_ALL,
  CLIENT: TXT_RECEIVER,
  SHIPOWNER: TXT_SHIPOWNER,
  SUPPLIER: TXT_SUPPLIER,
  AGENT: TXT_AGENT
};

export const CounterPartyTypeSingularLabels = {
  ALL: TXT_ALL,
  CLIENT: TXT_A_RECEIVER,
  SHIPOWNER: TXT_A_SHIPOWNER,
  SUPPLIER: TXT_A_SUPPLIER,
  AGENT: TXT_AN_AGENT
};

export type CounterPartyType = keyof typeof CounterPartyTypes;
export interface counterPartyModel extends baseNamedEntityModel {
  counterPartyTypes?: counterPartyTypeModel[];
  dealPopularity?: number;
  maritimeDirectories?: Omit<maritimeDirectoryModel, 'counterParty'>[];
  reference?: string;
  businessUnitId?: string;
  businessUnit?: businessUnitModel;
  bargeScope?: boolean;
}
